'use strict';

angular.module('app.shared.searchDropdown.searchDropdownController', [])
  .controller('app.shared.searchDropdown.searchDropdownController', [
    '$scope',
    ($scope) => {
      $scope.displayAttr =  $scope.displayAttr || null;
      $scope.selectedItems = $scope.selectedItems || null;
      $scope.allItems = $scope.allItems || null;
      $scope.readOnly = $scope.readOnly || null;
      $scope.idType = $scope.idType || null;
      $scope.selectAllOption = $scope.selectAllOption || null;
      $scope.grouping = $scope.grouping || null;
      $scope.groupingLabel = $scope.groupingLabel || null;
      $scope.sortDirection = $scope.sortDirection || null;
      $scope.sortBy = $scope.sortBy || null;
      $scope.singleOption = $scope.singleOption || false;

      $scope.filteredItems = [];
      $scope.search = {};

      let groupNames = [];

      $scope.selectItem = (obj) => {
        if(obj[$scope.idType] === 'all') {
          _.forEach($scope.allItems, (item) => {
            updateSelectedItems(item);
          })
        } else {
          updateSelectedItems(obj);
        }
      };

      $scope.selectGroup = (group) => {
        groupNames.indexOf(group) > -1 ? groupNames.splice(groupNames.indexOf(group), 1) : groupNames.push(group);

        let group_index = groupNames.indexOf(group);

        _.forEach($scope.allItems, (item) => {
          if(item[$scope.groupingLabel] === group) {
            let selectedId = Array.isArray($scope.selectedItems) ? $scope.selectedItems.find((id) => {
              return id === item[$scope.idType];
            }) : undefined;

            if(group_index > -1) {
              if(_.isUndefined(selectedId)) {
                $scope.addItem({item: item});
              }
            } else {
              if(!_.isUndefined(selectedId)) {
                $scope.removeItem({item: item});
              }
            }
          }
        });
      };

      $scope.isGroupSelected = (group) => {
        return groupNames.indexOf(group) > -1;
      };

      $scope.isItemSelected = function(item) {
        if ( typeof $scope.selectedItems === 'undefined' ) return false;

        let tmpItem;

        if(Array.isArray($scope.selectedItems)) {
          tmpItem = $scope.selectedItems.find((id) => {
            return id == item[$scope.idType];
          });

          if(tmpItem == 0) {
            return true;
          }

          return typeof $scope.selectedItems !== 'undefined' || tmpItem ? tmpItem : false;
        }

        return false;
      };

      $scope.commaDelimitedSelected = function() {
        if($scope.grouping && (!Array.isArray($scope.selectedItems) || !$scope.selectedItems.length)) {
          groupNames = [];
        }

        if($scope.singleOption) {
          return Array.isArray($scope.selectedItems) && $scope.selectedItems.length ? $scope.selectedItems[0][$scope.displayAttr] : "Select";
        }

        return Array.isArray($scope.selectedItems) && $scope.selectedItems.length ? $scope.selectedItems.length+' Selected' : "Select";
      };

      let updateSelectedItems = function(obj) {
        let selectedId;

        if(!Array.isArray($scope.selectedItems)) {
          $scope.selectedItems = [];
        }

        selectedId = $scope.selectedItems.find((id) => {
          return id === obj[$scope.idType];
        });


        if ( !selectedId ) {
          if($scope.singleOption && $scope.selectedItems.length) {
            console.log('hit1');
            $scope.selectedItems = [];
          }

          $scope.addItem({item: obj});
        } else {
          $scope.removeItem({item: obj});
          if($scope.singleOption && $scope.selectedItems.length) {
            console.log('hit2');
            $scope.selectedItems = [];
          }

          if($scope.grouping) {
            let group_index = groupNames.indexOf(obj[$scope.groupingLabel]);

            if(group_index > -1) {
              groupNames.splice(group_index, 1);
            }
          }
        }
      };

      $scope.toggled = (open) => {
        if(typeof $scope.callBack === "function") {
          $scope.callBack();
        }

        /*if(!open && $scope.search.query) {
          console.log($scope.search.query);
          $scope.search.query = '';
        }*/
      };

      let orgData = () => {
        let attribute = $scope.grouping ? $scope.groupingLabel : $scope.displayAttr;

        $scope.allItems.sort((a, b) => {
          let nameA = Number.isInteger(a[attribute]) ? a[attribute] : a[attribute].toUpperCase();
          let nameB = Number.isInteger(b[attribute]) ? b[attribute] : b[attribute].toUpperCase();

          if(nameA === nameB) {
            if($scope.grouping) {
              if($scope.sortBy) {
                nameA = Number.isInteger(a[$scope.sortBy]) ? a[$scope.sortBy] : a[$scope.sortBy].toUpperCase();
                nameB = Number.isInteger(b[$scope.sortBy]) ? b[$scope.sortBy] : b[$scope.sortBy].toUpperCase();
              } else {
                nameA = Number.isInteger(a[$scope.displayAttr]) ? a[$scope.displayAttr] : a[$scope.displayAttr].toUpperCase();
                nameB = Number.isInteger(b[$scope.displayAttr]) ? b[$scope.displayAttr] : b[$scope.displayAttr].toUpperCase();
              }

              if(nameA === nameB) {
                return 0;
              }

              return nameA < nameB ? -1 : 1;
            }

            return 0;
          }

          if($scope.sortDirection === 'desc') {
            return nameA < nameB ? 1 : -1;
          } else {
            return nameA < nameB ? -1 : 1;
          }
        });
      };

      $scope.$watch(() => {
        return (Array.isArray($scope.allItems) && $scope.allItems.length);
      }, () => {
        if(Array.isArray($scope.allItems) && $scope.allItems.length) {
          if($scope.sortDirection) {
            orgData();
          }
        }
      });
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/searchDropDown/searchDropDownController.js